export const CHECK_IN_PATIENT_TITLE_PREFIX = 'Do you want to check-in';
export const CHECK_IN_PATIENT_TITLE_SUFFIX =
  'and create a new patient profile?';
export const CHECK_IN_PATIENT_TITLE_DESCRIPTION_IF_PATIENT_PROFILE_DOES_NOT_EXISTS =
  'Please check the patient’s documents and confirm their identity before proceding with the patient profile creation.';
export const CHECK_IN_PATIENT_TITLE_DESCRIPTION_IF_PATIENT_PROFILE_EXISTS =
  'Please check the patient’s documents and confirm their identity before proceding with the check-in.';
